"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const SvgNavigationArrowLeft22Px = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 22, height: 22, fill: "none" }, props),
    React.createElement("path", { fill: "#666", d: "m9.037 2.45-7.772 7.772a1 1 0 0 0 0 1.415l7.685 7.685.707-.707L2.543 11.5H21v-1H2.401l7.343-7.342-.707-.707Z" })));
const Memo = (0, react_1.memo)(SvgNavigationArrowLeft22Px);
exports.default = Memo;
//# sourceMappingURL=NavigationArrowLeft22Px.js.map